import { render, staticRenderFns } from "./ExhibitionDetail.vue?vue&type=template&id=65e52e8c&scoped=true"
import script from "./ExhibitionDetail.vue?vue&type=script&lang=js"
export * from "./ExhibitionDetail.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionDetail.vue?vue&type=style&index=0&id=65e52e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e52e8c",
  null
  
)

export default component.exports